import Vue from 'vue'
import { extend, ValidationProvider, ValidationObserver, configure, setInteractionMode } from 'vee-validate'
import { isEmpty } from '../libs/helpTools'

const config = {
  skipOptional: false
}

configure(config)

extend('digit', {
  validate: value => !value || regexp.digit.test(value)
})

extend('dateValid', {
  validate: value => !value || regexp.date.test(value)
})

extend('email', {
  validate: value => !value || regexp.email.test(value)
})

extend('tel', {
  validate: value => !value || regexp.tel.test(value)
})

extend('name', {
  validate: value => !value || regexp.name.test(value)
})

extend('text', {
  validate: value => !value || regexp.text.test(value)
})

extend('required', {
  validate: value => !isEmpty(value)
})

extend('greaterThanZero', {
  validate: value => {
    return value > 0
  }
})

extend('boolean-required', {
  validate: Boolean
})

setInteractionMode('input', () => {
  return {
    on: ['input']
  }
})

setInteractionMode('click', ({ flags }) => {
  if (flags.touched) {
    return {
      on: ['click']
    }
  }
  return {
    on: ['input']
  }
})

extend('password', {
  validate: value => regexp.text.test(value)
})

extend('phoneValidate', {
  getMessage: (field) => {
    return 'The ' + field + ' value is not correct phone number.'
  },
  validate: (value, valid) => {
    return (valid[0] === 'true')
  }
})

setInteractionMode('touchBlur', ({ flags }) => {
  if (flags.touched) {
    return {
      on: ['input']
    }
  }
  return {
    on: ['blur']
  }
})

export const regexp = {
  email: /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+[.][A-Za-z]+$/,
  tel: /^((8|\+7)[- ]?)?(\(?\d{3}\)?[- ]?)?[\d\- ]{7,10}$/,
  name: /^[а-яА-Яa-zA-Z]+(( |-)?[а-яА-Яa-zA-Z]+)*$/,
  text: /^(?!\s*$).+/,
  digit: /^([0-9]+)$/,
  date: /\d{2}[.]\d{2}[.]\d{2,4}$/
}

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
